import React, { useContext } from 'react';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

import { styled } from '../../../Utils/style';
import { MaterialDialog, MaterialDialogContent, MaterialDialogTitle, MaterialTypography } from '../../../index';

const IframeStyled = styled('iframe')`
  width: 100%;
  height: 100%;
`;

const QnAPopup = (props) => {
  const { open, onClose } = props;
  const { actions } = useContext(MainContext);
  const { t } = useTranslation();

  const iframeSrc = actions.settings.getUserConfigProp(`widgetsConfig.QnAPopup.iframeSrc`);

  return (
    <MaterialDialog variant="large" fullWidth open={open} onClose={onClose} aria-labelledby="qna-dialog-title">
      <MaterialDialogTitle disableTypography onClose={onClose} withDivider={false}>
        <MaterialTypography id="qna-dialog-title" variant="h2">
          {t('QnAPopup.title')}
        </MaterialTypography>
      </MaterialDialogTitle>
      <MaterialDialogContent>
        <IframeStyled src={iframeSrc} />
      </MaterialDialogContent>
    </MaterialDialog>
  );
};

export default QnAPopup;
